import { Mutation } from 'vuex';
import { IModuleState } from './types';

export const setEncryptionTypes: Mutation<IModuleState> = (state, payload) => {
  state.encryptionType.data = payload.data;
  state.encryptionType.loading = !!payload.loading;
};

export const setMessageTypes: Mutation<IModuleState> = (state, payload) => {
  state.messageType.data = payload.data;
  state.messageType.loading = !!payload.loading;
};

export const setEmailList: Mutation<IModuleState> = (state, payload) => {
  state.emailList.data = payload.data;
  state.emailList.loading = !!payload.loading;
};

export const setSMSList: Mutation<IModuleState> = (state, payload) => {
  state.smsList.data = payload.data;
  state.smsList.loading = !!payload.loading;
};
